<div *ngIf="isReactive" class="itb-switch" [formGroup]="parentForm">
  <mat-slide-toggle [checked]="value" ngClass="{{className}}" [labelPosition]="labelPosition"
    [formControlName]="formFieldName" (change)="changeEvent($event)">
    {{label}}</mat-slide-toggle>
    <itb-divider [className]="'mat-divider'"></itb-divider>
</div>

<div *ngIf="!isReactive && hasDivider" class="itb-switch">
  <mat-slide-toggle [disabled]="isDisabled" [checked]="value" ngClass="{{className}}" [labelPosition]="labelPosition"
    (change)="changeEvent($event)">
    {{label}}</mat-slide-toggle>
    <itb-divider [className]="'mat-divider'"></itb-divider>
</div>

<div *ngIf="!isReactive && !hasDivider" class="itb-switch">
  <mat-slide-toggle [disabled]="isDisabled" [checked]="value" ngClass="{{className}}" [labelPosition]="labelPosition"
    (change)="changeEvent($event)">
    {{label}}</mat-slide-toggle>
</div>